import { all } from 'redux-saga/effects'

export function* saga() {
  yield all([])
}
